export default __webpack_public_path__ + "static/media/ico.0b15e8eb.png";